import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import * as URLS from '../../../URLS';
import { ButtonComponent } from '../../../shared/components/button/button.component';

export enum NavTabsEnum {
  Mixtures,
  Materials
}

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterModule, TranslateModule, ButtonComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  public linkHome = '/' + URLS.HOME;
  public linkMaterials = '/' + URLS.MATERIALS;
  public linkMixtures = '/' + URLS.MIXTURES;
  public activeTab = NavTabsEnum.Mixtures;
  public NavTabsEnum = NavTabsEnum;

  /**
   * SignIn Users
   *
   * @param {NavTabsEnum} tab The tab that was pressed
   */
  public onTabChanged(tab: NavTabsEnum): void {
    this.activeTab = tab;
  }

  /**
   * SignIn Users
   */
  public signIn(): void {
    console.log('Login Pressed');
  }
}
